<template>
  <div id="mouseover"
       class="unselectable clickArea use-pointer"
       @mouseover="mover"
       @mouseleave="mleave"
       @mousedown="mdown"
       @mouseup="mup"
       @touchstart="tstart"
       @touchmove="tmove"
       @touchcancel="tcancel"
       @touchend="tend"
       @click="fireEvent"
       :style="{ maxWidth:width, maxHeight:height }"
  >
    <img
      draggable="false"
      class="no-pointer"
	  :src="nowsrc"
      :srcset="nowsrc + ' 1x,' + nowHi2 + ' 2x,' + nowHi3 + ' 3x'"
      alt="mouse over"
      id="imgelement"
      :width="width"
      :height="height"
    />
    <p>{{ isMouseover ? "mouseover" : "mouseleave" }}</p>
  </div>
</template>

<script>
  let debugOut = false
  export default {
  name: "Mouseover",
  props: {
    srcname: {
      type: String,
      required: true,
      default: "img_off.png"
    },
    width: {
      type: [Number,String],
      required: true,
    },
    height: {
      type: [Number,String],
      required: true,
    },
  },
  computed: {
    nowsrc: function() {
      return this.isDisable ? this.dsImg : this.isPush ? this.phImg : this.isMouseover ? this.onImg : this.imgsrc;
    },
    nowHi2: function() {
      return this.isDisable ? this.dsHi2 : this.isPush ? this.phHi2 : this.isMouseover ? this.onHi2 : this.hiSrc2;
    },
    nowHi3: function() {
      return this.isDisable ? this.dsHi3 : this.isPush ? this.phHi3 : this.isMouseover ? this.onHi3 : this.hiSrc3;
    },
   },
  mounted() {
    this.supportTouch = 'ontouchend' in document;
   },
  data: function() {
    return {
      isMouseover: false,
	  isPush: false,
	  isDisable: false,
      imgsrc: require("../assets/" + this.srcname),
      hiSrc2: require("../assets/" + this.srcname.replace(/(.*)\.(jpe?g|gif|png)/g, "$1@2x.$2")),
      hiSrc3: require("../assets/" + this.srcname.replace(/(.*)\.(jpe?g|gif|png)/g, "$1@3x.$2")),
      onImg: require("../assets/" + this.srcname.replace(/(.*)_off\.(jpe?g|gif|png)/g, "$1_on.$2")),
      onHi2: require("../assets/" + this.srcname.replace(/(.*)_off\.(jpe?g|gif|png)/g, "$1_on@2x.$2")),
      onHi3: require("../assets/" + this.srcname.replace(/(.*)_off\.(jpe?g|gif|png)/g, "$1_on@3x.$2")),
	  phImg: require("../assets/" + this.srcname.replace(/(.*)_off\.(jpe?g|gif|png)/g, "$1_push.$2")),
	  phHi2: require("../assets/" + this.srcname.replace(/(.*)_off\.(jpe?g|gif|png)/g, "$1_push@2x.$2")),
	  phHi3: require("../assets/" + this.srcname.replace(/(.*)_off\.(jpe?g|gif|png)/g, "$1_push@3x.$2")),
	  dsImg: require("../assets/" +	this.srcname.replace(/(.*)_off\.(jpe?g|gif|png)/g, "$1_dis.$2")),
	  dsHi2: require("../assets/" + this.srcname.replace(/(.*)_off\.(jpe?g|gif|png)/g, "$1_dis@2x.$2")),
	  dsHi3: require("../assets/" + this.srcname.replace(/(.*)_off\.(jpe?g|gif|png)/g, "$1_dis@3x.$2")),
    };
  },
  created() {
    debugOut = this.$root.$options.debugOut
  },
  methods: {
    // mouseover時の処理
    changeImg: function(e) {
      this.isMouseover = true;
    },
    // mouseleave時の処理
    returnImg: function(e) {
      this.isMouseover = false;
	  this.normalBack(e)
    },
	pushBack: function(e) {
		this.isPush = true;
	},
	normalBack: function(e) {
		this.isPush = false;
	},
	fireEvent: function () {
		this.$emit('click');
	},
    mover: function(e) {
      if (this.isDisable || this.supportTouch) return;
      this.changeImg();
    },
    mleave: function(e) {
      if (this.isDisable || this.supportTouch) return;
      this.returnImg();
    },
    mdown: function(e) {
      if (this.isDisable || this.supportTouch) return;
      this.pushBack();
    },
    mup: function(e) {
      if (this.isDisable || this.supportTouch) return;
      this.normalBack();
    },
    tstart: function(e) {
      window.getSelection().removeAllRanges()
      if (this.isDisable || !this.supportTouch) return
      this.changeImg()
      if (debugOut) {console.log('tstart!')}
    },
    tmove: function(e) {
      window.getSelection().removeAllRanges()
      if (this.isDisable || !this.supportTouch) return
      if (debugOut) {console.log('tmove!')}
    },
    tcancel: function(e) {
      window.getSelection().removeAllRanges()
      if (this.isDisable || !this.supportTouch) return
      this.returnImg()
      if (debugOut) {console.log('tcancel!')}
    },
    tend: function(e) {
      window.getSelection().removeAllRanges()
      if (this.isDisable || !this.supportTouch) return
      this.returnImg()
      if (debugOut) {console.log('tend!')}
    },
  }
};
</script>

<style scoped>

.clickArea {
    display: inline-block;
}
</style>
